import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { SemanticTokens } from './semantic';
import { ComponentTokens } from './components';

export const Theme = definePreset(Aura, {
    semantic: SemanticTokens,
    components: ComponentTokens
});
